import React from 'react';
import {
  Flex,
  
  IconButton,
  Text,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Image,
} from '@chakra-ui/react';

import {  BsThreeDotsVertical } from 'react-icons/bs';

import { useNavigate } from 'react-router-dom';
// import { FaListCheck } from "react-icons/fa6";
import {  MdNotifications } from 'react-icons/md';
// import StopWatch from '../Components/stopWatch';
import { useGetLoggedInUser } from '../utils/user.api';
import Logo from '../Assets/headerLogo.png';
import ProfileIconSvg from'../Assets/icons/profileIcon.svg';

const WebNav = () => {
  const navigate = useNavigate();


  const getLoginedUser = useGetLoggedInUser();

  // console.log('getLoggedIn user...', getLoginedUser);


  return (
    <>
      <Flex
        justify="space-between"
        bgColor={'#21234a'}
        borderBottom="1px solid #3b3c5b"
        p={4}
        // display={{ base: 'none', md: 'flex' }}
      >
        <Box display="flex">
          <Flex
            mr="5em"
            direction="row"
            bg="transparent"
            cursor="pointer"
            alignItems="center"
            mb="7px"
            color="#FFFFFF"
            onClick={() => navigate('/dashboard')}
          >
            {/* <CgStack size="25px" style={{ transform: 'rotate(90deg)' }} />
             */}
            <Image src={Logo} w={10} h={10} mr={2} />
            <Text fontSize={'17px'} fontWeight={'medium'}>
              Trust  Construction
            </Text>
          </Flex>
         
        </Box>

        {/* Right side */}
        <Flex align="center">
        {/* Profile Icon and Name */}
        <Box display="flex" alignItems="center" mr={4}>
          <Image
            src={getLoginedUser?.data?.image || ProfileIconSvg}
            alt="User Profile"
            borderRadius="full"
            boxSize="40px"
            border="2px solid white"
            mr={3}
          />
          <Box>
            <Text fontSize="sm" color="white" fontWeight="bold">
              {getLoginedUser?.data?.username || 'Philip Maya'}
            </Text>
            <Text fontSize="xs" color="whiteAlpha.700">
              {getLoginedUser?.data?.email || 'Philipmaya@mail.com'}
            </Text>
          </Box>
        </Box>

        {/* Notification Icon */}
      

        {/* More Options (3 dots) */}
        <Menu>
          <MenuButton as={IconButton} icon={<BsThreeDotsVertical color="white" size="20px" />} variant="outlined" color="white" />
          <MenuList>
            <MenuItem onClick={() => navigate('/profile')}>Profile</MenuItem>
            <MenuItem
              onClick={() => {
                localStorage.clear();
                // navigate('/');
                window.location.reload();
              }}
            >
              Log out
            </MenuItem>
          </MenuList>
        </Menu>

        <IconButton
          aria-label="Notifications"
          icon={<MdNotifications color="white" size="30px" />}
          variant="outlined"
          color="white"
          size="lg"
          mr={4}
        />
      </Flex>
      </Flex>
    </>
  );
};

export default WebNav;
